var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_back_home",style:({ left: _vm.position ? _vm.position.left - 50 + 'px' : null }),on:{"click":_vm.goBackHome}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/back-home-icon.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }